<script lang="ts">
    import {  Form, FormGroup, Input } from "sveltestrap";
    import { Master, SelectType, Visa } from "../../../../utils/Constant/Constant";
</script>
<Form class="theme-form mega-form">
    <FormGroup>
      <Input type="text" placeholder="Card number" />
    </FormGroup>
    <FormGroup>
      <Input type="text" placeholder="First Name" />
    </FormGroup>
    <FormGroup>
      <Input type="date" />
    </FormGroup>
    <FormGroup>
      <Input type="text" placeholder="Name on card" />
    </FormGroup>
    <FormGroup>
      <Input type="select" name="select" value="Select Type" id="exampleSelect" >
        <option>{SelectType}</option>
        <option>{Master}</option>
        <option>{Visa}</option>
      </Input>
    </FormGroup>
</Form>